import React from "react";
import styled, { css } from "styled-components";
import { Typography } from "../../general/Typography";

export interface TableCellProps {
  children: React.ReactNode;
  align?: "left" | "center" | "right";
  bold?: boolean;
  muted?: boolean;
  compact?: boolean;
  hideOnMobile?: boolean;
}

const StyledCell = styled.div<{
  align?: "left" | "center" | "right";
  hideOnMobile?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ align }) =>
    align === "center"
      ? "center"
      : align === "right"
      ? "flex-end"
      : "flex-start"};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ hideOnMobile, theme }) =>
    hideOnMobile &&
    css`
      @media (max-width: ${theme.breakpoints.tablet}) {
        display: none;
      }
    `}
`;

export const TableCell: React.FC<TableCellProps> = ({
  children,
  align = "left",
  bold = false,
  muted = false,
  compact = false,
  hideOnMobile = false,
}) => {
  return (
    <StyledCell align={align} hideOnMobile={hideOnMobile}>
      <Typography
        as="span"
        variant={compact ? "caption" : "bodySmall"}
        weight={bold ? "bold" : "regular"}
        colorScheme={muted ? "muted" : undefined}
        ellipsis
      >
        {children}
      </Typography>
    </StyledCell>
  );
};